export default {
  INVOICES_FILTER: store => {
    return store.invoicesFilter;
  },
  PAYROLLS_FILTER: store => {
    return store.payrollsFilter;
  },
  EXPENSES_FILTER: store => {
    return store.expensesFilter;
  },
};
